<template>
    <div>
        <div v-if="children.length >= 10" class="list-page remove-buffer">
            <div class="input-container">
                <div class="input-box"><input v-model="search" type="text" placeholder="Quick Search Children"><span class="fa fa-search"></span></div>
            </div>
        </div>
        <div v-if="children.length > 0 && filteredChildren.length === 0" class="list-page">
            <div class="list-container">
                <div class="table">
                    <nothing-here :is-filtered="!!search"></nothing-here>
                </div>
            </div>
        </div>
        <div class="big-buttons-container">
            <a v-for="child in filteredChildren" :href="`/settings/children/select/${ child.id }/overview`" class="big-button">
                <div class="left">
                    <div class="headline">{{ child.first_name }} {{ child.last_name.charAt(0) }}.</div>
                    <div class="text">
                        <div class="info"><span class="fa fa-signal"></span> Current Level <span class="status-bubble" :class="levelClass(child.level)">{{ child.level }}</span></div>
                        <div class="info"><span class="fa fa-calendar"></span> {{ age(child) }} Year{{ age(child) !== 1 ? 's' : '' }} Old</div>
                        <div class="info"><span class="fa fa-stamp"></span> {{ child.num_stamps }} Stamp{{ child.num_stamps !== 1 ? 's' : '' }}</div>
                    </div>
                </div>
                <div class="right-photo" :style="`background:url('${ thumbnail(child) }') center center no-repeat; background-size:cover;`"></div>
            </a>
            <a v-if="isSubscribed" href="/settings/children/create" class="big-button">
                <div class="left">
                    <div class="headline">Add New Child</div>
                    <div class="text">
                        You have {{ childrenAvailable }} child {{ childrenAvailable !== 1 ? 'slots' : 'slot' }} available with your account's current billing level.
                    </div>
                </div>
                <div class="right-photo"><span class="fa fa-plus"></span></div>
            </a>
            <a v-if="!isSubscribed" href="/billing/history" class="big-button">
                <div class="left">
                    <div class="headline">Create a Subscription</div>
                    <div class="text">
                        Your account does not currently have a subscription. Click here to manage your subscription so you can add your own children to our platform.
                    </div>
                </div>
                <div class="right-photo"><span class="fa fa-plus"></span></div>
            </a>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import moment from 'moment';
import ChildMixin from '@/mixins/ChildMixin';
import LevelsMixin from '@/mixins/LevelsMixin';

export default {

    props: [ 'children', 'numTotalChildren', 'isSubscribed' ],

    mixins: [ ChildMixin, LevelsMixin ],

    data() {
        return {
            search: '',
        }
    },

    computed: {

        ...mapState({
            account: state => state.account,
        }),

        filteredChildren() {
            if (!this.search || this.search.length === 0) return this.children;

            return this.children.filter(child => {
                const searchable = child.first_name + ' ' + child.last_name;
                return searchable.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
            });
        },

        childrenAvailable() {
            return this.account.max_children_allowed - this.numTotalChildren;
        }
    },

    methods: {

        age(child) {
            return moment().diff(moment(child.birthdate), 'years');
        },

    },
}

</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/Dashboard.vue